// Set up your root reducer here...
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import common from './common';
import userInfo from './userInfo';
import offlinePayments from './offlinePayment';
import deferralPayments from './deferralPayment';
import coupon from './coupon';

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    common: common,
    userInfo: userInfo,
    offlinePayments,
    deferralPayments,
    coupon,
  });
